import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-usuarios-filtro-area',
  templateUrl: './modal-usuarios-filtro-area.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./modal-usuarios-filtro-area.component.css']
})
export class ModalUsuariosFiltroAreaComponent implements OnInit {

  constructor(private modalService: NgbModal) {
  }

  cadastrar(content) {
    const ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      windowClass: 'modalUsuariosFiltroArea',
      size: 'lg'
    };
    this.modalService.open(content, ngbModalOptions).result.then((result) => {
    }, (reason) => {
    });
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/permissoes-acesso/modal-usuarios-filtro-area/modal-usuarios-filtro-area.component.ts